import { createAction } from '../../../store.model';
import { ActionType } from '../main.action';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface Reset {}

export const reset = createAction<ActionType, Reset>(
    ActionType.EVAL_MAIN__RESET,
);
